import React, { useState, useEffect } from 'react';
import { Horse } from './types';
import { loadHorsesData } from './horsesData';
import ContractDocumentList from './ContractDocumentList';
import ContractUploadDialog from './ContractUploadDialog';
import './ContractDocumentsView.css';

const ContractDocumentsView: React.FC = () => {
  const [horses, setHorses] = useState<Horse[]>([]);
  const [showUpload, setShowUpload] = useState(false);
  const [docRefresh, setDocRefresh] = useState(0);

  useEffect(() => {
    loadHorsesData()
      .then(({ horses }) => setHorses(horses))
      .catch(err => console.error('Failed to load horses:', err));
  }, []);

  return (
    <div className="contract-docs-view">
      <header className="header">
        <h2>Vertragsdokumente</h2>
        <h4>Alle gespeicherten und hochgeladenen Verträge</h4>
      </header>

      <div className="docs-toolbar">
        <button onClick={() => setShowUpload(true)} className="btn-upload-new">
          + Vertrag hochladen
        </button>
      </div>

      <ContractDocumentList refreshTrigger={docRefresh} />

      {showUpload && (
        <ContractUploadDialog
          horses={horses}
          onClose={() => setShowUpload(false)}
          onUploaded={() => {
            setDocRefresh(prev => prev + 1);
          }}
        />
      )}
    </div>
  );
};

export default ContractDocumentsView;
